import { Location } from './location.model';
import {
  PayPeriodEnum,
  ScopeOfPracticeEnum,
  ShiftStatusEnum,
  ShiftTypeEnum
} from '@umss/shared/utils';

export interface RateInfo {
  contractorNormalHourlyRate?: number | null;
  contractorNormalEstimatedPayment?: number | null;
  contractorUrgentHourlyRate?: number | null;
  contractorUrgentEstimatedPayment?: number | null;
  facilityNormalHourlyRate?: number | null;
  facilityNormalEstimatedPayment?: number | null;
  facilityUrgentHourlyRate?: number | null;
  facilityUrgentEstimatedPayment?: number | null;
}

// We keep them as numbers and use the Display fields for UI
export interface ShiftNeed {
  createdAt?: string;
  updatedAt?: string;
  id: string;
  facilityId: string;
  facilityName: string;
  facilitySubtypeId?: number;
  facilitySubtypeName?: string;
  scopeOfPractice: ScopeOfPracticeEnum;
  scopeOfPracticeDisplay: string;
  shiftType: ShiftTypeEnum;
  shiftTypeDisplay?: string;
  shiftDate: string;
  startTime: string;
  endTime: string;
  numberOfPositions?: number;
  hourlyRate: number;
  specialInstructions?: string;
  description?: string;
  status: ShiftStatusEnum;
  statusDisplay?: string;
  expiresAt?: string;
  postedByName?: string;
  estimatedHours: number;
  estimatedPayment: number;
  isUrgent?: boolean;
  isExpired?: boolean;
  distanceMiles?: number;
  facilityLocation?: Location;
  facilityFullAddress?: string;
  payPeriodType?: PayPeriodEnum;
  firstPaymentDay?: number;
  secondPaymentDay?: number;
  paymentScheduleDisplay?: string;
  isRecurring?: boolean;
  recurringPatternId?: number;
  rateInfo?: RateInfo;
  assignedContractors?: AssignedContractorDto[];
  assignedCount?: number;
  /** Facility invited a contractor; contractor hasn't responded yet. */
  pendingInviteCount?: number;
  /** Contractor applied; facility hasn't responded yet. */
  pendingApplicationCount?: number;
  /** Facility's turn to act: negotiating (contractor last counter-offered) or contractor_accepted awaiting confirm. */
  awaitingFacilityActionCount?: number;
  shiftIds?: string[];
  actualStartTime?: string;
  actualEndTime?: string;
  latestCounterOfferRate?: number | null;
  latestCounterOfferBy?: 'contractor' | 'facility' | null;
  latestCounterOfferAt?: string | null;
  latestCounterOfferMessage?: string | null;
}
export interface AssignedContractorDto {
  contractorId: string;
  contractorName: string;
  profileImageUrl?: string;
}
